<script setup>
import SquareScore from '@/Components/Chart/SquareScore.vue';
import Card from '@/Components/Card/Card.vue';
import Pill from '@/Components/Pill.vue';
</script>

<template>
  <Card class="z-10 sm:flex">
    <div class="flex flex-col items-center gap-6">
      <div class="font-bold">
        {{ $t('domain_score.partials.branding_card.branding') }}
      </div>
      <SquareScore :score="0" />
      <div>{{ $t('domain_score.partials.branding_card.high_risk') }}</div>
      <div class="flex flex-wrap justify-center gap-1">
        <Pill>BIMI</Pill>
        <Pill>{{ $t('domain_score.partials.branding_card.image') }}</Pill>
        <Pill>{{ $t('domain_score.partials.branding_card.certificate') }}</Pill>
      </div>
    </div>
  </Card>
</template>
